<p-card
    #card
    class="dashboard">
    <ng-template pTemplate="header">
        <p-toolbar>
            <div class="p-toolbar-group-start">
                <span class="p-card-title"> {{ currentLayout()?.title }} </span>
            </div>
            <div class="p-toolbar-group-end">
                <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text p-button-lg"
                    pTooltip="Edit"
                    tooltipPosition="top"
                    (click)="editClick.emit()"></button>
                <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-desktop"
                    class="p-button-rounded p-button-text p-button-lg"
                    pTooltip="Full screen mode"
                    tooltipPosition="top"
                    (click)="setFullScreen()"></button>
                <button
                    pButton
                    pRipple
                    type="button"
                    class="p-button-rounded p-button-text p-button-lg"
                    pTooltip="Reflow"
                    tooltipPosition="top"
                    (click)="reflow()">
                    reflow {{ isNotReflow ? 'off' : 'on' }}
                </button>
                <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-file-export"
                    class="p-button-rounded p-button-text p-button-lg"
                    pTooltip="Export"
                    tooltipPosition="top"
                    (click)="export()"></button>
            </div>
        </p-toolbar>
    </ng-template>
    <ng-template pTemplate="content">
        <section id="content">
            <gridstack
                #dhaboardFramework
                [options]="gridStackOptions"
                class="grid-height"
                [class.fullscreen-height]="isFullScreen"
                [ngClass]="isNotReflow ? 'not-reflow' : 'reflow'">
                <!-- [class.reflow]="isNotReflow"
                [class.not-reflow]="!isNotReflow" -->
                @for (widget of widgets(); track widget.id) {
                    <gridstack-item [options]="widget">
                        <dashboard-widget [widgetConfiguration]="widget"></dashboard-widget>
                    </gridstack-item>
                }
            </gridstack>
        </section>
    </ng-template>
</p-card>
